import React from 'react';
import kcbLogo from '../assets/kcb-logo.svg';
import equityLogo from '../assets/equity-bank-logo.svg';
import coopLogo from '../assets/coop-bank-logo.svg';
import ncbaLogo from '../assets/ncba-logo.svg';
import mpesaLogo from '../assets/mpesa-logo.svg';
import paystackLogo from '../assets/paystack-logo.svg';
import fwLogo from '../assets/flutterwave-logo.svg';
import atLogo from '../assets/at-logo.svg';
import twilioLogo from '../assets/twilio-logo.svg';

const Partnerships = () => {
  return (
    <section className="partnerships">
      <div className="partnerships-container">
        <div className="partnerships-text-container">
          <div className="partnerships-title">Frictionless Payments</div>
          {/* <p className="partnerships-subtitle text-muted">Our platform has seamless integrations with leading brands letting you leverage their services to grow your business</p> */}
          <p className="partnerships-subtitle text-muted">We provide diverse, secure and convenient payment integrations that drive customer satisfaction</p>



        </div>
        <div className="partnerships-logos-container">
          <img src={kcbLogo} alt="KCB" className="partnerships-logo" />
          <img src={equityLogo} alt="Equity" className="partnerships-logo" />
          <img src={coopLogo} alt="Coop" className="partnerships-logo" />
          <img src={ncbaLogo} alt="NCBA" className="partnerships-logo" />
          <img src={mpesaLogo} alt="M-Pesa" className="partnerships-logo" />
          <img src={paystackLogo} alt="Paystack" className="partnerships-logo" />
          <img src={fwLogo} alt="Flutterwave" className="partnerships-logo" />
          {/* <img src={twilioLogo} alt="Twilio" className="partnerships-logo" /> */}
          {/* <img src="/alterbone.svg" alt="Alterbone" className="partnerships-logo" />
          <img src="/carbonia.svg" alt="Carbonia" className="partnerships-logo" />
          <img src="/tinygone.svg" alt="Tinygone" className="partnerships-logo" />
          <img src="/preso.svg" alt="Preso" className="partnerships-logo" />
          <img src="/ridoria.svg" alt="Ridoria" className="partnerships-logo" />
          <img src="/incanto.svg" alt="Incanto" className="partnerships-logo" /> */}
        </div>
      </div>
    </section>
  );
};

export default Partnerships; 